var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartPieSlice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11V2.75",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1447 6.875L3.85529 15.125",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88757 12.5082C2.53038 10.5752 2.87405 8.57809 3.85687 6.87562C4.83968 5.17315 6.39726 3.87684 8.24989 3.21948V9.41232L2.88757 12.5082Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.75C12.4454 2.75027 13.8654 3.13028 15.1177 3.85198C16.3701 4.57368 17.4108 5.61175 18.1358 6.86222C18.8607 8.11269 19.2444 9.53167 19.2484 10.9771C19.2525 12.4225 18.8767 13.8436 18.1587 15.0981C17.4407 16.3525 16.4057 17.3964 15.1574 18.125C13.9091 18.8537 12.4912 19.2416 11.0458 19.2499C9.60044 19.2582 8.17824 18.8866 6.92164 18.1723C5.66504 17.458 4.61815 16.4262 3.8858 15.18",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPieSlice);
export default __webpack_public_path__ + "static/media/chartPieSlice.eaea8aa085db9c4140d26ce129d09130.svg";
export { ForwardRef as ReactComponent };